import { render, staticRenderFns } from "./AddOrderItem.vue?vue&type=template&id=54dfd3c8&"
import script from "./AddOrderItem.vue?vue&type=script&lang=js&"
export * from "./AddOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports